export default __webpack_public_path__ + "resources/icons/d131-7695.png";